// ═══════════════════════════════════════════════════════════
// Color Constants — JS references matching GAB tokens
// ═══════════════════════════════════════════════════════════

export const primary = {
  50: '#F7F8FD', 100: '#EEF1FC', 200: '#D4DDFB', 300: '#B8C6FB',
  400: '#94A8FF', 500: '#7589FF', 600: '#5A65FF', 700: '#4B3FFF',
  800: '#2C01D6', 900: '#19009B',
};

export const secondary = {
  50: '#F7F9FA', 100: '#F0F2F4', 200: '#D8DFE5', 300: '#BECBD6',
  400: '#9CB1C3', 500: '#8099AE', 600: '#758CA0', 700: '#546574',
  800: '#3F4C58', 900: '#2B343D',
};

export const neutral = {
  50: '#F8F8F8', 100: '#F2F2F2', 200: '#DDDEDE', 300: '#C8C9CA',
  400: '#ADAFB1', 500: '#939598', 600: '#7B7D7F', 700: '#616365',
  800: '#494A4C', 900: '#323334',
};

export const semantic = {
  success: '#037730',
  warning: '#885604',
  error: '#D33423',
  info: '#0E6F7F',
};

export const brand = {
  blurple: '#4B3FFF',
  navy: '#2C01D6',
  darkNavy: '#19009B',
  slate: '#546574',
};
